import { CommonModule } from '@angular/common';
import { Component, effect, input, signal } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter, tap } from 'rxjs';
import { CollapsibleDirective } from '../../directives/collapsibleDirective.directive';
import { NavigationItem } from '../../interfaces/navigationList.interface';
import { PageContainerService } from '../../services/page-container.service';

@Component({
    selector: 'st-menu-collapse-item',
    imports: [CommonModule, CollapsibleDirective, RouterModule],
    templateUrl: './menu-collapse-item.component.html',
    styleUrls: ['./menu-collapse-item.component.scss']
})
export class MenuCollapseItemComponent {
  menuItemData = input.required<NavigationItem>();
  active = input<boolean>(false);
  isActive = signal<boolean>(false);
  isCollapsed = signal<boolean>(false);
  activeChild!: NavigationItem | null;

  events$ = this.router.events.pipe(
    filter(x => x instanceof NavigationEnd),
    tap(x => {
      this.getRoutePath();
    }),
  );

  constructor(
    readonly router: Router,
    readonly pageContainerService: PageContainerService,
  ) {
    effect(
      () => {
        this.isActive.set(this.active());
        if (this.isActive() && this.menuItemData()) {
          this.getRoutePath();
          this.isCollapsed.set(true);
        } else {
          this.activeChild = null;
        }
      },
      { allowSignalWrites: true },
    );
  }

  collapse() {
    this.isCollapsed.update(x => !x);
    if (!this.menuItemData().children.length) {
      this.pageContainerService.changeTab$.next(this.menuItemData());

      if (this.menuItemData().routeUrl.length)
        this.router.navigate([this.menuItemData().routeUrl]);
    }
  }

  onClick(url: string) {
    if (url.length) this.router.navigate([url]);

    this.pageContainerService.changeTab$.next(this.menuItemData());
    let currentPath = this.pageContainerService
      .getRoutePath()
      .find(x => x.url === url)?.routePath;
    if (currentPath) this.setActiveItem(currentPath);
  }

  getRoutePath() {
    let currentPath = this.pageContainerService
      .getRoutePath()
      .find(x => x.url === this.router.url.split('?')[0])?.routePath;

    if (currentPath) this.setActiveItem(currentPath);
  }

  setActiveItem(currentPath: number[]) {
    const index = this.menuItemData().children.findIndex(
      y => y && currentPath && y.id === currentPath[2],
    );
    if (index === -1) {
      return;
    }
    this.activeChild = this.menuItemData().children[index];
    this.pageContainerService.selectLastChild$.next(this.activeChild);
  }
}
